import NextImage from 'next/image';
import { type ReactElement } from 'react';

import { type VideoPlayerData } from '../video-player';

type Props = {
  data: VideoPlayerData<'blurUpThumb' | 'height' | 'thumbnailUrl' | 'width'>;
};

export const VideoThumbnail = (props: Props): ReactElement => {
  const {
    data: {
      video: {
        alt,
        video: { blurUpThumb, height, thumbnailUrl, width },
      },
    },
  } = props;

  const thumbUrlObj = new URL(thumbnailUrl);
  thumbUrlObj.searchParams.set('time', '0');

  return (
    <NextImage
      alt={alt}
      height={height}
      placeholder={blurUpThumb}
      src={thumbUrlObj.href}
      style={{ cursor: 'wait' }}
      width={width}
    />
  );
};
